import { render, staticRenderFns } from "./SurfacePostAuthor.vue?vue&type=template&id=363177e1&"
import script from "./SurfacePostAuthor.vue?vue&type=script&lang=ts&"
export * from "./SurfacePostAuthor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports